import { render, staticRenderFns } from "./SecretaryUsers.vue?vue&type=template&id=11149aec"
import script from "./SecretaryUsers.vue?vue&type=script&lang=js"
export * from "./SecretaryUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports